
/*
  ==========================================================
  JS 说明
  ==========================================================
 
  - 这段 JS 会直接初始化页面中的各类 section。
  - JS 不依赖外层模块容器或页面宽度容器。
  - 会分别初始化：
    .awp-auto-water-magazine
    .awp-auto-water-center
    .awp-auto-water-brand
    .awp-auto-water-orbit
 
  - 当前代码使用 querySelectorAll，因此：
    1. section 可以重新排序；
    2. section 可以缺失；
    3. 相同 section 可以出现多个；
    4. CSS 外层结构保持原样，JS 只负责 section 动画初始化。
 
  - fromIf() 是安全动画方法：
    如果某个目标元素不存在，会直接跳过，不会报错。
 
  - 如果后续将本 script 拆为独立 JS 文件：
    GSAP 和 ScrollTrigger 必须先加载。
*/
(() => {
  window.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  gsap.registerPlugin(ScrollTrigger);

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isMobile = window.matchMedia("(max-width: 960px)").matches;

  if (prefersReducedMotion) return;

  // 直接扫描页面中的 section，不依赖外层模块容器或页面宽度容器。
  // CSS 外层结构保持原样；这里只负责扫描 section 并初始化动画。
  document.querySelectorAll(".awp-auto-water-magazine").forEach(initMagazineSection);
  document.querySelectorAll(".awp-auto-water-center").forEach(initCenterStatement);
  document.querySelectorAll(".awp-auto-water-brand").forEach(initBrandSection);
  document.querySelectorAll(".awp-auto-water-orbit").forEach(initOrbitSection);

  // 根据 awp-auto-water-pc-image-left 判断 PC 端横向入场方向；手机端返回 0，避免横向溢出。
  function getDesktopOffset(section, defaultOffset) {
    if (isMobile) return 0;
    return section.classList.contains("awp-auto-water-pc-image-left")
      ? -defaultOffset
      : defaultOffset;
  }

  // 安全添加 GSAP 动画：目标不存在时跳过，避免缺失 section 或缺失子元素时报错。
  function fromIf(timeline, targets, vars, position) {
    const list = targets instanceof Element ? [targets] : gsap.utils.toArray(targets);
    if (!list.length) return timeline;
    return timeline.from(list, vars, position);
  }

  // 初始化 04 Magazine 模块动画。
  function initMagazineSection(section) {
    const textX = getDesktopOffset(section, -56);
    const imageX = getDesktopOffset(section, 88);
    const imageRotate = isMobile
      ? 0
      : section.classList.contains("awp-auto-water-pc-image-left")
        ? -4
        : 4;

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 78%",
        once: true
      }
    });

    if (isMobile && section.classList.contains("awp-auto-water-mobile-text-bottom")) {
      fromIf(timeline, section.querySelector(".awp-auto-water-product-img"), {
        x: 0,
        y: 36,
        rotate: 0,
        scale: 0.9,
        opacity: 0,
        duration: 0.95,
        ease: "back.out(1.35)"
      });

      fromIf(timeline, section.querySelectorAll("h4, p"), {
        x: 0,
        y: 28,
        opacity: 0,
        duration: 0.78,
        stagger: 0.12,
        ease: "power3.out"
      }, "-=0.45");

      fromIf(timeline, section.querySelectorAll(".awp-auto-water-chip"), {
        y: 18,
        opacity: 0,
        duration: 0.48,
        stagger: 0.06,
        ease: "back.out(1.8)"
      }, "-=0.35");

      return;
    }

    fromIf(timeline, section.querySelectorAll("h4, p"), {
      x: textX,
      y: isMobile ? 28 : 0,
      opacity: 0,
      duration: 0.78,
      stagger: 0.12,
      ease: "power3.out"
    });

    fromIf(timeline, section.querySelectorAll(".awp-auto-water-chip"), {
      y: 18,
      opacity: 0,
      duration: 0.48,
      stagger: 0.06,
      ease: "back.out(1.8)"
    }, "-=0.35");

    fromIf(timeline, section.querySelector(".awp-auto-water-product-img"), {
      x: isMobile ? 0 : imageX,
      y: isMobile ? 36 : 18,
      rotate: imageRotate,
      scale: 0.9,
      opacity: 0,
      duration: 0.95,
      ease: "back.out(1.35)"
    }, "-=0.65");
  }

  // 初始化 05 Center 模块动画。
  function initCenterStatement(section) {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 78%",
        once: true
      }
    });

    fromIf(timeline, section.querySelector("h4"), {
      y: 42,
      scale: 0.94,
      opacity: 0,
      duration: 0.82,
      ease: "power3.out"
    });

    fromIf(timeline, section.querySelector("p"), {
      y: 24,
      opacity: 0,
      duration: 0.64,
      ease: "power2.out"
    }, "-=0.36");

    fromIf(timeline, section.querySelector(".awp-auto-water-product-img"), {
      y: 70,
      scale: 0.78,
      rotate: -5,
      opacity: 0,
      duration: 1,
      ease: "elastic.out(1, 0.75)"
    }, "-=0.16");
  }

  // 初始化 06 Brand 模块动画。
  function initBrandSection(section) {
    const textX = getDesktopOffset(section, -54);
    const imageX = getDesktopOffset(section, 78);

    const revealClipPath = isMobile
      ? "inset(100% 0 0 0)"
      : section.classList.contains("awp-auto-water-pc-image-left")
        ? "inset(0 100% 0 0)"
        : "inset(0 0 0 100%)";

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 76%",
        once: true
      }
    });

    fromIf(timeline, section, {
      clipPath: revealClipPath,
      duration: 0.9,
      ease: "power3.out"
    });

    if (isMobile && section.classList.contains("awp-auto-water-mobile-text-bottom")) {
      fromIf(timeline, section.querySelector(".awp-auto-water-product-img"), {
        x: 0,
        y: 34,
        scale: 0.92,
        opacity: 0,
        duration: 0.92,
        ease: "power3.out"
      }, "-=0.35");

      fromIf(timeline, section.querySelectorAll("h4, p"), {
        x: 0,
        y: 26,
        opacity: 0,
        duration: 0.72,
        stagger: 0.12,
        ease: "power2.out"
      }, "-=0.35");

      fromIf(timeline, section.querySelectorAll(".awp-auto-water-chip"), {
        y: 24,
        opacity: 0,
        duration: 0.48,
        stagger: 0.07,
        ease: "back.out(1.7)"
      }, "-=0.25");

      return;
    }

    fromIf(timeline, section.querySelectorAll("h4, p"), {
      x: textX,
      y: isMobile ? 26 : 0,
      opacity: 0,
      duration: 0.72,
      stagger: 0.12,
      ease: "power2.out"
    }, "-=0.35");

    fromIf(timeline, section.querySelectorAll(".awp-auto-water-chip"), {
      y: 24,
      opacity: 0,
      duration: 0.48,
      stagger: 0.07,
      ease: "back.out(1.7)"
    }, "-=0.25");

    fromIf(timeline, section.querySelector(".awp-auto-water-product-img"), {
      x: isMobile ? 0 : imageX,
      y: isMobile ? 34 : 0,
      scale: 0.92,
      opacity: 0,
      duration: 0.92,
      ease: "power3.out"
    }, "-=0.65");
  }

  // 初始化 08 Orbit 模块动画。
  function initOrbitSection(section) {
    const leftItems = section.querySelectorAll(
      ".awp-auto-water-orbit-list:first-child .awp-auto-water-orbit-item"
    );

    const rightItems = section.querySelectorAll(
      ".awp-auto-water-orbit-list:last-child .awp-auto-water-orbit-item"
    );

    const productImage = section.querySelector(
      ".awp-auto-water-orbit-product .awp-auto-water-product-img"
    );

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 78%",
        once: true
      }
    });

    fromIf(timeline, section.querySelectorAll(".awp-auto-water-orbit-header h4, .awp-auto-water-orbit-header p"), {
      y: 34,
      opacity: 0,
      duration: 0.72,
      stagger: 0.1,
      ease: "power3.out"
    });

    fromIf(timeline, leftItems, {
      x: isMobile ? 0 : -54,
      y: isMobile ? 24 : 0,
      opacity: 0,
      duration: 0.65,
      stagger: 0.12,
      ease: "power2.out"
    }, "-=0.2");

    fromIf(timeline, rightItems, {
      x: isMobile ? 0 : 54,
      y: isMobile ? 24 : 0,
      opacity: 0,
      duration: 0.65,
      stagger: 0.12,
      ease: "power2.out"
    }, "-=0.55");

    fromIf(timeline, productImage, {
      scale: 0.76,
      rotate: 5,
      opacity: 0,
      duration: 0.9,
      ease: "back.out(1.45)"
    }, "-=0.28");
  }
  
});
})();